<template>
  <div
    v-if="show"
    class="search-dropdown"
  >
    <div class="search-dropdown__tabs">
      <button
        v-for="tab of tabs"
        :key="tab"
        :class="{ active: activeTab === tab }"
        type="button"
        @click="activeTab = tab"
      >
        {{ tab }}
      </button>
    </div>
    <div
      v-if="hasResultsForActiveTab"
      class="search-dropdown__results"
    >
      <ul v-if="activeTab === 'PRODUCTS' && limitedProducts.length > 0 && query">
        <li
          v-for="(product, index) of limitedProducts"
          :key="product.id"
          class="search-dropdown__product-card"
        >
          <product-card
            :product="product"
            :lazyload="index > 4"
          />
        </li>
      </ul>
      <ul v-if="activeTab === 'Collections'">
        <li v-if="collections.length === 0">
          {{ $string('collection.no_results') }}
        </li>
        <pre>{{ collections }}</pre>
        <li
          v-for="collection of collections"
          :key="collection.id"
        >
          <a
            :href="collection.url"
            class="search-dropdown__collection-link"
            tabindex="0"
          >
            <span>{{ collection.title }}</span>
          </a>
        </li>
      </ul>
      <ul v-if="activeTab === 'Pages'">
        <li
          v-for="page of pages"
          :key="page.id"
        >
          <span>{{ page.title }}</span>
        </li>
      </ul>
      <div
        v-if="activeTab === 'PRODUCTS' && products.length > 5"
        class="search-dropdown__view-all"
      >
        <btn
          :label="$string('search.view_all')"
          :url="searchUrl"
          class="search__primary"
          modifiers=""
        />
      </div>
    </div>
    <div
      v-if="query && (
        (activeTab === 'PRODUCTS' && limitedProducts.length === 0) ||
        (activeTab === 'Collections' && collections.length === 0) ||
        (activeTab === 'Pages' && pages.length === 0)
      )"
      class="search-dropdown__no-results"
    >
      {{ $string('search.no_results') }}
    </div>
  </div>
</template>

<script>
import ProductCard from '~async/product-card/product-card'
import Btn from '~global/btn/btn.vue'
export default {
  name: 'SearchDropdown',
  components: {
    ProductCard,
    Btn,
  },
  props: {
    show: Boolean,
    products: {
      type: Array,
      default: () => [],
    },
    collections: {
      type: Array,
      default: () => [],
    },
    pages: {
      type: Array,
      default: () => [],
    },
    query: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeTab: 'PRODUCTS',
    }
  },
  computed: {
    hasResultsForActiveTab() {
      if (!this.query) {
        return true
      }
      if (this.activeTab === 'PRODUCTS') {
        return this.limitedProducts.length > 0
      }
      if (this.activeTab === 'Collections') {
        return this.collections.length > 0
      }
      if (this.activeTab === 'Pages') {
        return this.pages.length > 0
      }
      return true
    },
    tabs() {
      const tabs = []
      if (this.products.length > 0) {
        tabs.push('PRODUCTS')
      }
      if (this.collections.length > 0) {
        tabs.push('Collections')
      }
      if (this.pages.length > 0) {
        tabs.push('Pages')
      }
      return tabs
    },
    limitedProducts() {
      return this.products.slice(0, 5)
    },
    searchUrl() {
      // Use the same search URL logic as in main-search.vue
      const base = this.$variable
        ? this.$variable('routes.search') || '/search'
        : '/search'
      return this.query
        ? `${base}?q=${encodeURIComponent(this.query)}`
        : base
    },
  },
}
</script>

<style lang="scss">
@import './search-dropdown.scss';
</style>
